import { render, staticRenderFns } from "./toPayOrder.vue?vue&type=template&id=b521bfd2&scoped=true"
import script from "./toPayOrder.vue?vue&type=script&lang=js"
export * from "./toPayOrder.vue?vue&type=script&lang=js"
import style0 from "./toPayOrder.vue?vue&type=style&index=0&id=b521bfd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b521bfd2",
  null
  
)

export default component.exports